<template>
  <Alert v-if="hasTeamRole(TEAM_ROLE.INVITED)" type="warning">
    <template #description>
      You've been invited to a team! Check the invitation
      <InertiaLink href="/team/invitations" class="tw-link">here.</InertiaLink>
    </template>
  </Alert>
</template>

<script setup>
import Alert from '@/shared/components/Alert.vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { TEAM_ROLE } from '@/shared/data/permissionSystem.js'

const { hasTeamRole } = usePermissionSystem()
</script>
